<template>
  <section class="featured-book">
    <div class="section-inner">
      <div class="section-header">
        <h2 class="section-title">有记录，阅读才真正发生</h2>
        <router-link class="view-all" to="/book">全部书籍 →</router-link>
      </div>

      <div class="content-wrap">
        <div class="book-card" v-for="item in bookList" :key="item.id">
          <div class="book-category">{{ item.category }}</div>
          <h2 class="book-title">{{ item.title }}</h2>
          <p class="book-subtitle">{{ item.description }}</p>
          <p class="book-desc">{{ item.readNote }}</p>
          <div class="quote-block">
            <p>{{ item.quote }}</p>
          </div>
          <div class="tag-row">
            <span
                class="status-tag"
                v-for="tag in item.tags"
                :key="tag"
                :class="{
                'tag-finish': tag === '已读完',
                'tag-reading': tag === '在读'
              }"
            >
              {{ tag }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import {onMounted, ref} from "vue";
import request from "@/api/request";
import showToast from "@/utils/toast";
const bookList = ref([])
const queryHotBookList = async () => {
  try {
    const response = await request.get("/v1/api/book/queryHotBookList")
    const resp = response.data
    if (resp.responseCode === '0000') {
      bookList.value = resp.data
    }else {
      showToast(resp.responseDesc)
    }
  } catch (e) {
    showToast(e.message)
  }
}
onMounted(async () => {
  await queryHotBookList()
})
</script>

<style scoped>
.featured-book {
  margin: 0 0 40px 0;
  width: 80%;
}

.section-inner {
  width: 100%;
  margin: 0 auto;
}

.section-header {
  margin-top: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 48px;
}

.section-title {
  font-size: 40px;
  color: var(--laputa-common-font-color);
  font-weight: 600;
  text-align: left;
  line-height: 1.4;
  margin: 0;
}

.view-all {
  font-size: 19px;
  color: var(--laputa-common-secondary-font-color);
  text-decoration: none;
}

.content-wrap {
  display: flex;
  gap: 40px;
  align-items: stretch;
}

.book-card {
  flex: 1;
  padding: 40px;
  background: var(--laputa-body-background-other);
  border-radius: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
}

.book-category {
  display: inline-block;
  font-size: var(--laputa-fontsize-12);
  color: var(--laputa-primary);
  background: var(--laputa-card-background-very-pale-sky-blue);
  padding: 6px 14px;
  border-radius: 999px;
  margin-bottom: 14px;
  width: fit-content;
}

.book-title {
  font-size: 36px;
  margin: 0 0 10px;
  color: var(--laputa-common-sub-font-color);
}

.book-subtitle {
  font-size: 19px;
  color: var(--laputa-common-secondary-font-color);
  margin: 0 0 20px;
  font-weight: 500;
}

.book-desc {
  font-size: 16px;
  color: var(--laputa-common-thirdary-font-color);
  line-height: 1.72;
  margin: 0 0 28px;
}

/* 统一金句区块，主题蓝色 */
.quote-block {
  background-color: var(--laputa-book-ref);
  border-left: 5px solid var(--laputa-primary);
  border-radius: 20px;
  padding: 24px 28px;
  margin-bottom: 28px;
}
.quote-block p {
  margin: 0;
  font-size: 18px;
  line-height: 1.7;
  color: var(--laputa-ref-font-color);
  font-weight: 500;
}

.tag-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: auto;
}

.tag {
  padding: 8px 18px;
  background: #f3f6f8;
  color: #444;
  border-radius: 999px;
  font-size: 14px;
}

@media (max-width: 1100px) {
  .content-wrap {
    flex-direction: column;
    gap: 32px;
  }
  .book-card {
    padding: 32px;
  }
  .book-title {
    font-size: 30px;
  }
}
@media (max-width: 768px) {
  .featured-book{
    width: 94%;
  }
}
</style>
